<template>
  <div class="explosion-overlay"></div>
</template>

<style scoped>
.explosion-overlay {
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 5;
}
</style>
